// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1XBKV","content":"GlobalSearch_content__3ZMRx"};